var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1893",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1364 24.4349C11.0387 24.779 10.3666 25.111 10.3299 25.4309C10.1955 26.6682 15.3217 29.2455 20.0081 29.2455C24.6944 29.2455 29.8145 26.6863 29.6923 25.4731C29.6618 25.1411 28.9836 24.7971 28.8797 24.441L11.1364 24.4349Z",
    fill: "url(#paint0_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3014 25.666C12.0529 25.9437 13.7637 27.0241 20.0019 27.0241C26.2402 27.0241 27.951 25.9377 28.7025 25.666C30.3338 25.0685 30.0406 22.0868 28.7025 22.3282C27.7616 22.4972 22.7697 23.5052 20.0081 23.5052C17.2464 23.5052 11.4725 22.3282 11.4725 22.3282C9.88389 22.2618 9.65783 25.0021 11.3136 25.666H11.3014Z",
    fill: "url(#paint1_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3137 22.3225C11.3137 22.3225 13.4583 22.745 15.7678 23.0891C18.3829 24.2057 18.7984 26.1432 18.7984 26.1432C15.0652 23.8436 12.9267 23.8979 12.5479 23.7711C11.4114 23.3909 9.74343 24.8153 13.33 25.9742C15.3035 26.608 18.0346 26.7106 20.0081 26.7106L20.002 27.0184C13.7638 27.0184 12.053 25.938 11.3015 25.6603H11.3137C10.5683 25.3586 10.1711 24.6403 10.11 23.9462C10.1467 23.0891 10.5561 22.3285 11.3137 22.3225Z",
    fill: "url(#paint2_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.6233 25.1593C11.5154 25.4973 13.5255 26.614 19.9532 26.614C26.7413 26.614 28.5987 25.3826 29.4236 25.105H29.4297C29.2525 25.3525 29.0142 25.5456 28.7026 25.6603C27.9511 25.9379 26.2403 27.0184 20.0021 27.0184C13.7638 27.0184 12.053 25.9379 11.3015 25.6603H11.3137C11.0266 25.5516 10.8005 25.3766 10.6233 25.1593Z",
    fill: "url(#paint3_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.0081 26.7104C21.9816 26.7104 24.7372 26.6681 26.6863 25.974C29.5457 24.96 28.2443 23.3907 27.8471 23.3303C27.45 23.2699 26.5641 23.4812 25.2199 24.1753C23.8757 24.8695 23.4174 24.2538 22.1038 24.4952C20.7902 24.7367 20.0264 25.4911 19.1038 26.1249L20.5091 23.4872C20.5519 23.4872 20.5947 23.4812 20.6374 23.4812C20.6374 23.4812 20.6374 23.4812 20.6435 23.4812C20.6863 23.4812 20.7291 23.4752 20.7718 23.4752H20.778C20.8207 23.4752 20.8635 23.4691 20.9124 23.4691H20.9185C20.9612 23.4691 21.0101 23.4631 21.0529 23.4631C23.4724 23.3001 26.7474 22.6784 28.1587 22.4189C28.1649 22.4189 28.171 22.4189 28.1771 22.4189C28.2015 22.4129 28.226 22.4129 28.2443 22.4068C28.2504 22.4068 28.2565 22.4068 28.2565 22.4068C28.2748 22.4008 28.2993 22.4008 28.3176 22.3947C28.3237 22.3947 28.3298 22.3947 28.3359 22.3887C28.3543 22.3827 28.3726 22.3827 28.3909 22.3766C28.397 22.3766 28.4093 22.3766 28.4154 22.3706C28.4276 22.3706 28.4459 22.3646 28.4581 22.3646C28.4642 22.3646 28.4765 22.3585 28.4826 22.3585C28.4948 22.3585 28.507 22.3525 28.5192 22.3525C28.5253 22.3525 28.5376 22.3465 28.5437 22.3465C28.5559 22.3465 28.562 22.3404 28.5742 22.3404C28.5803 22.3404 28.5926 22.3344 28.5987 22.3344C28.6109 22.3344 28.6231 22.3283 28.6353 22.3283C28.6414 22.3283 28.6475 22.3283 28.6537 22.3283C28.672 22.3283 28.6842 22.3223 28.7025 22.3223C29.4479 22.2016 29.7412 22.9561 29.7901 23.8434C29.7473 24.5918 29.4663 25.3885 28.7025 25.6662C27.951 25.9438 26.2402 27.0243 20.002 27.0243",
    fill: "url(#paint4_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.22 23.4268C10.3544 22.7991 10.7882 22.2981 11.4726 22.3223C11.4726 22.3223 17.2464 23.4993 20.0081 23.4993C22.7698 23.4993 27.7616 22.4913 28.7026 22.3223C29.1364 22.2438 29.4602 22.5033 29.6435 22.9138C28.8553 22.7025 28.1282 22.9017 27.3889 23.0164C26.4113 23.1673 26.1364 23.7709 25.0977 23.8614C24.059 23.9519 22.226 24.0727 21.6761 24.3745C21.1262 24.6763 19.5865 25.3945 19.2994 25.9257L17.833 25.3945C17.833 25.3945 15.4196 24.0123 14.7108 23.8916C14.0021 23.7709 11.9247 23.0466 10.9471 23.3182C10.6599 23.4027 10.4155 23.4268 10.22 23.4268Z",
    fill: "url(#paint5_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.391 25.4792C11.8879 26.5657 14.8513 27.3745 20.008 27.3745C25.1648 27.3745 28.122 26.5657 29.6251 25.4792C29.6434 25.4611 29.6679 25.449 29.6862 25.4309C29.8206 26.6683 29.4907 27.7306 28.7453 28.2678C27.3827 29.2577 24.6944 29.994 20.008 29.994C15.3217 29.994 12.6334 29.2577 11.2708 28.2678C10.5254 27.7245 10.1955 26.6683 10.3299 25.4309C10.3482 25.443 10.3727 25.4611 10.391 25.4792Z",
    fill: "url(#paint6_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.843 21.2298C28.4886 21.1574 27.7554 21.3143 25.5864 21.7369C23.4174 22.1594 11.8879 21.6765 11.0814 21.417C10.4949 21.2298 9.83501 22.5336 10.2749 22.938C10.5193 23.1553 10.6782 22.7992 11.6558 22.9923C14.3747 23.5235 15.9511 23.8132 18.7983 26.1491C18.8899 26.2215 19.0244 26.2155 19.1038 26.131C19.5498 25.6783 20.9429 24.3202 21.8899 24.0486C23.0386 23.7166 25.2687 23.952 26.4113 23.1734C27.5477 22.3948 29.6801 23.1251 29.4968 22.2559C29.344 21.5316 29.1974 21.3023 28.843 21.2298Z",
    fill: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.2444 22.3224C14.393 22.6121 17.9796 23.2579 19.1527 23.0769C20.3258 22.8958 23.8879 22.7268 24.6027 22.7026C25.3176 22.6785 25.9775 23.107 24.4805 23.0467C22.9836 22.9863 21.4806 23.1372 20.9001 23.4692C20.3197 23.8012 19.6231 25.3403 19.4704 24.7065C19.3176 24.0728 19.0121 23.9219 18.0957 24.1633C17.1792 24.4047 17.0264 23.5295 15.9877 23.4692C14.949 23.4088 14.0936 22.8656 12.78 22.594C11.4664 22.3224 11.2586 21.8214 13.2444 22.3224Z",
    fill: "url(#paint7_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M10.4155 21.761C10.5988 21.5075 10.8493 21.3445 11.0815 21.417C11.888 21.6705 23.4174 22.1594 25.5865 21.7369C27.7555 21.3144 28.4948 21.1514 28.8431 21.2299C29.0325 21.2721 29.1669 21.3566 29.2708 21.5437C28.9714 21.749 28.4398 21.8274 28.2504 21.749C27.4989 21.4351 27.3095 21.7972 27.0345 22.0266C26.7596 22.256 26.6863 21.7731 26.338 21.9542C25.9897 22.1352 25.5437 22.6785 25.3298 22.6785C25.116 22.6785 24.5356 22.6905 24.3523 22.7388C24.169 22.7871 23.5274 22.5698 23.3441 22.5095C23.1608 22.4491 23.0081 22.4974 23.0081 22.4974C23.0081 22.4974 22.5498 22.7268 22.5071 22.9078C22.4643 23.0889 22.1099 22.7751 22.006 22.7388C21.9022 22.7026 21.4684 23.0708 21.1812 23.0708C20.894 23.0708 20.7841 22.9501 20.3258 22.5397C20.1608 22.3948 19.2566 23.27 19.1649 23.4028C19.0733 23.5356 18.6639 23.1131 18.3584 22.9139C18.0529 22.7147 17.8696 22.932 17.5947 23.1432C17.3197 23.3545 17.3992 23.3364 17.1059 23.0527C16.8126 22.769 16.2138 22.3646 16.1283 22.4431C16.0427 22.5215 16.0672 22.9984 15.7311 22.7328C15.4929 22.5457 14.9368 22.5819 14.7047 22.6724C14.4725 22.763 14.2464 22.6604 14.2159 22.6302C14.1853 22.6 13.5988 22.262 13.1161 21.9602C12.9939 21.8878 11.6314 22.099 11.3442 22.1775C11.057 22.256 10.721 22.1775 10.721 22.1775C10.721 22.1775 10.5682 21.8938 10.4155 21.761Z",
    fill: "url(#paint8_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M28.9469 20.1495C29.2524 20.3306 29.9673 20.5238 29.9978 20.6022C30.0284 20.6807 29.7351 20.8437 29.3746 21.1455C29.0691 21.399 28.6292 21.5559 28.397 21.5559C28.1648 21.5559 27.3094 21.4835 27.0345 21.7068C26.7595 21.9301 26.6801 21.6766 26.3319 21.8577C25.9836 22.0388 25.5376 22.3526 25.3237 22.3526C25.1099 22.3526 24.5294 22.3647 24.3461 22.413C24.1628 22.4613 23.5213 22.244 23.338 22.1836C23.1547 22.1233 23.0019 22.1716 23.0019 22.1716C23.0019 22.1716 22.5437 22.4009 22.5009 22.582C22.4582 22.7631 22.1038 22.4492 21.9999 22.413C21.896 22.3768 21.4622 22.745 21.1751 22.745C20.8879 22.745 20.503 22.6544 20.3197 22.5337C20.1364 22.413 19.2504 22.9442 19.1588 23.0769C19.0671 23.2097 18.7005 23.0045 18.395 22.8053C18.0896 22.6061 17.8574 22.6122 17.5885 22.8174C17.3197 23.0226 17.393 23.0105 17.0997 22.7269C16.8065 22.4432 16.2077 22.25 16.1222 22.3345C16.0366 22.419 15.9389 22.6242 15.725 22.407C15.5112 22.1897 14.9307 22.2561 14.6985 22.3466C14.4664 22.4371 14.2403 22.3345 14.2097 22.3043C14.1792 22.2742 13.666 22.1172 13.1833 21.8215C13.0611 21.749 11.6252 21.7732 11.3381 21.8517C11.0509 21.9301 10.7149 21.8517 10.7149 21.8517C10.7149 21.8517 10.5132 21.4533 10.3422 21.3809C10.165 21.3084 10 21.1092 10 21.0489C10 20.9885 10.1222 20.9583 10.2138 20.7954C10.3055 20.6324 10.5255 20.4875 10.6538 20.3608C10.7821 20.234 15.7739 20.9161 15.7739 20.9161L23.6068 20.9644L27.3461 20.3306L28.9469 20.1495Z",
    fill: "url(#paint9_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M26.9306 19.6182C27.5843 20.0829 28.5008 20.4028 28.9285 20.6624C29.3562 20.9219 28.6658 20.9581 28.2686 20.9883C27.8715 21.0185 28.1464 21.4108 27.6149 21.3082C27.0833 21.2056 27.065 20.9159 26.5273 21.0789C25.9896 21.2418 26.8145 19.582 26.8756 19.6001",
    fill: "url(#paint10_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M16.9104 21.6887C17.6313 21.9362 17.613 22.1414 17.9185 22.3225C18.224 22.5036 18.2973 21.9905 19.061 22.1233C19.8248 22.2561 19.5254 21.7974 20.5885 22.1837C21.6517 22.57 21.4928 22.2802 21.2728 22.1354C21.0529 21.9905 21.6089 21.731 21.1384 21.574C20.668 21.4111 18.3706 21.1877 18.3156 21.2119C18.2606 21.236 16.9104 21.6887 16.9104 21.6887Z",
    fill: "url(#paint11_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M27.8777 20.2703C27.6883 20.735 27.5783 21.1696 27.4989 21.5619C27.3095 21.58 27.1384 21.6223 27.0406 21.7068C27.1812 21.2903 27.2606 20.7954 27.2667 20.3487L27.3461 20.3367L27.8777 20.2703Z",
    fill: "url(#paint12_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M10.4644 20.5238C10.5316 20.4695 10.5989 20.4151 10.6477 20.3668C10.776 20.2401 15.7617 20.9221 15.7617 20.9221L23.5947 20.9704L25.666 20.6203C25.5376 21.1998 25.4521 21.8456 25.1588 22.3587C25.055 22.3587 24.9267 22.3647 24.7983 22.3708C24.945 22.1716 25.1527 22.0991 25.1038 21.6646C25.0427 21.1032 24.4867 20.6143 23.9063 21.5619C23.7169 21.8698 23.4969 22.0388 23.2464 22.1716C23.0998 22.1414 22.9898 22.1776 22.9898 22.1776C22.9898 22.1776 22.6965 22.3225 22.556 22.4734C22.4705 22.5096 22.3788 22.5518 22.2933 22.6001C22.1772 22.5398 22.0428 22.4372 21.9817 22.419C21.9694 22.413 21.945 22.419 21.9206 22.4251C22.4582 21.8396 22.7087 21.1394 21.7006 21.5801C20.4175 22.1414 19.9715 21.6404 18.9939 22.5337C18.8412 22.6726 18.6762 22.7872 18.499 22.8838C18.4562 22.8597 18.4135 22.8295 18.3768 22.8053C18.3096 22.7631 18.2485 22.7329 18.1874 22.7088C18.6517 22.4794 19.3299 21.7672 18.7251 21.8034C17.9735 21.8517 15.9939 21.4111 14.7353 22.1052C14.5642 22.2018 14.387 22.2742 14.222 22.3285C14.2037 22.3225 14.1915 22.3104 14.1915 22.3044C14.1609 22.2742 13.6844 22.1293 13.2139 21.8517C13.2322 21.8396 13.2506 21.8336 13.2689 21.8215C14.2648 21.3507 12.4257 21.0972 11.5581 21.4714C10.8677 21.7853 10.0551 21.1093 10.4644 20.5238Z",
    fill: "url(#paint13_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.0143 20.2763C11.4542 20.6022 10.6538 20.7954 10.5866 21.0247C10.5194 21.2541 10.721 20.898 11.5948 21.073C12.4685 21.248 12.7923 21.073 13.2322 21.1153C13.6721 21.1575 12.4807 19.9081 12.2974 19.9081C12.1141 19.9081 11.0143 20.2763 11.0143 20.2763Z",
    fill: "url(#paint14_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M13.6722 21.2361C13.6844 21.2422 13.7027 21.2543 13.7149 21.2603C14.2037 21.5805 14.271 21.9732 14.5765 22.0578C14.8942 22.1484 14.5154 21.8645 14.6803 21.7376C14.8453 21.6047 14.2037 21.1153 14.2037 21.1153",
    fill: "url(#paint15_linear_950_2214)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M29.1668 20.3063C29.1668 20.3063 27.0344 21.9964 19.9469 21.9964C18.0284 21.9964 16.4765 21.8757 15.23 21.6946C15.0773 21.6704 14.784 21.6946 14.6374 21.6704C14.5091 21.6523 14.5335 21.5859 14.4174 21.5618C11.9062 21.1091 10.8981 20.4452 10.7515 20.3365C11.4969 20.3244 15.7616 20.9099 15.7616 20.9099L23.5945 20.9582L27.3338 20.3244L28.9407 20.1434C29.0018 20.1796 29.0874 20.2218 29.179 20.2581C29.179 20.2822 29.1729 20.3003 29.1668 20.3063Z",
    fill: "url(#paint16_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M10.7332 18.8217C10.7332 18.8217 12.8656 20.1375 19.9531 20.1375C27.0406 20.1375 29.1669 18.8036 29.1669 18.8036H29.2158C29.2647 19.2261 29.2463 20.0228 29.1669 20.1918C29.1669 20.1918 27.0345 21.7491 19.947 21.7491C12.8595 21.7491 10.7271 20.21 10.7271 20.21C10.6538 20.0409 10.6355 19.2442 10.6782 18.8217H10.7332Z",
    fill: "url(#paint17_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M29.1302 18.7069C29.228 18.7552 29.228 18.894 29.1302 18.9423C28.4215 19.3045 25.8309 20.3607 19.9531 20.3607C14.0754 20.3607 11.4847 19.2984 10.776 18.9423C10.6782 18.894 10.6782 18.7552 10.776 18.7069C11.4847 18.3448 14.0754 17.2885 19.9531 17.2885C25.8309 17.2824 28.4215 18.3448 29.1302 18.7069Z",
    fill: "url(#paint18_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M10.33 25.4309C10.3483 25.449 10.3728 25.4611 10.3911 25.4792C10.5194 25.5758 10.666 25.6663 10.8188 25.7568C11.1548 26.2276 11.3748 26.8916 12.1752 27.459C13.5499 28.4247 15.6578 29.2516 20.0081 29.2516C27.5356 29.2516 28.5437 26.9761 29.118 25.8051C29.3013 25.7025 29.4663 25.5939 29.619 25.4852C29.6374 25.4671 29.6618 25.4551 29.6801 25.4369C29.8146 26.6743 29.4846 27.7366 28.7392 28.2738C27.3767 29.2637 24.6883 30.0001 20.002 30.0001C15.3157 30.0001 12.6273 29.2637 11.2648 28.2738C10.5255 27.7245 10.1956 26.6683 10.33 25.4309Z",
    fill: "url(#paint19_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M20.008 10.1239C12.7555 10.1239 10.1161 14.8138 10.1161 17.548C10.1161 19.8236 16.8981 19.8899 20.008 19.8899C23.118 19.8899 29.9 19.8175 29.9 17.548C29.9 14.8138 27.2605 10.1239 20.008 10.1239Z",
    fill: "url(#paint20_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    opacity: 0.75,
    d: "M19.7271 10.1239C19.8187 10.1239 19.9104 10.1239 20.0081 10.1239C22.2199 10.1239 23.9979 10.5585 25.4093 11.2405C26.9673 13.2324 26.4846 15.4174 22.6659 14.3671C18.1446 13.1237 17.2648 12.164 19.7271 10.1239Z",
    fill: "url(#paint21_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M16.7514 10.486C12.9877 14.7413 20.7535 17.8558 24.8349 17.4574C28.7452 17.0771 28.5558 13.8178 24.8715 11.005C28.4825 12.4899 29.9 15.544 29.9 17.5479C29.9 19.8235 23.118 19.8899 20.008 19.8899C16.8981 19.8899 10.1161 19.8174 10.1161 17.5479C10.1161 15.2664 11.949 11.6328 16.7514 10.486Z",
    fill: "url(#paint22_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M20.008 19.8962C16.8981 19.8962 10.1161 19.8237 10.1161 17.5542C10.1161 15.6228 11.4236 12.7255 14.7352 11.1864C11.7169 15.0916 15.8961 17.8802 18.5966 18.2303C22.1587 18.695 29.0935 19.2926 29.6129 15.8582C29.8084 16.4618 29.9 17.0412 29.9 17.5542C29.9 19.8237 23.118 19.8962 20.008 19.8962Z",
    fill: "url(#paint23_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M24.279 15.484C24.2607 15.4659 24.224 15.4719 24.2179 15.5021C24.1935 15.6351 24.1385 15.9432 24.1751 16.058C24.2179 16.209 24.3523 16.2996 24.4745 16.2694C24.5967 16.2332 24.6578 16.0821 24.6151 15.9311C24.5845 15.8163 24.3768 15.5867 24.279 15.484Z",
    fill: "url(#paint24_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M22.9164 14.6637C22.9287 14.6879 22.9653 14.6879 22.9714 14.6637C23.0142 14.5248 23.0997 14.2468 23.0936 14.126C23.0875 13.9568 23.0142 13.8239 22.9225 13.83C22.8309 13.836 22.7576 13.9689 22.7637 14.1381C22.7698 14.2529 22.8676 14.5308 22.9164 14.6637Z",
    fill: "url(#paint25_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M20.6434 15.4665C20.6618 15.4906 20.6984 15.4786 20.6984 15.4484C20.6862 15.2731 20.6495 14.9167 20.6007 14.7777C20.5273 14.5784 20.4051 14.4454 20.3135 14.4757C20.228 14.5059 20.2157 14.6871 20.283 14.8865C20.3379 15.0254 20.5396 15.3154 20.6434 15.4665Z",
    fill: "url(#paint26_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M27.725 14.2768C27.7495 14.2647 27.7495 14.2285 27.7189 14.2224C27.5723 14.1802 27.2668 14.1077 27.1385 14.1137C26.9613 14.1258 26.8208 14.2043 26.8269 14.301C26.833 14.3916 26.9796 14.4581 27.1568 14.452C27.2851 14.4399 27.5784 14.3312 27.725 14.2768Z",
    fill: "url(#paint27_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M25.3055 12.6227C25.3299 12.6045 25.3177 12.5683 25.2932 12.5683C25.1283 12.5562 24.7739 12.532 24.6334 12.5683C24.444 12.6166 24.3157 12.7374 24.3401 12.8402C24.3645 12.9429 24.5417 12.9852 24.7311 12.9368C24.8717 12.9066 25.1649 12.7133 25.3055 12.6227Z",
    fill: "url(#paint28_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M20.7474 12.3936C20.778 12.3936 20.7902 12.3574 20.7657 12.3393C20.6374 12.2366 20.3686 12.013 20.2281 11.9586C20.0448 11.8922 19.8676 11.9163 19.8309 12.013C19.7943 12.1097 19.9104 12.2486 20.0937 12.3151C20.2281 12.3695 20.5824 12.3876 20.7474 12.3936Z",
    fill: "url(#paint29_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M22.6537 10.631C22.6414 10.6069 22.6048 10.6129 22.5987 10.6371C22.562 10.7579 22.4948 10.9996 22.5009 11.1023C22.5131 11.2413 22.5987 11.35 22.6903 11.344C22.782 11.3379 22.8431 11.2171 22.8308 11.0721C22.8247 10.9633 22.7086 10.7398 22.6537 10.631Z",
    fill: "url(#paint30_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M20.4296 10.6194C20.454 10.6315 20.4785 10.6073 20.4724 10.5771C20.4174 10.4502 20.3013 10.1965 20.2219 10.1119C20.1119 10.0031 19.9653 9.9669 19.898 10.0334C19.8308 10.0998 19.8614 10.2448 19.9714 10.3596C20.0508 10.4442 20.3074 10.565 20.4296 10.6194Z",
    fill: "url(#paint31_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M17.7474 10.5223C17.7229 10.5102 17.6985 10.5343 17.7046 10.5585C17.7596 10.6975 17.8879 11.0177 17.9795 11.1143C18.1017 11.2473 18.2728 11.2896 18.3584 11.211C18.4439 11.1325 18.4133 10.9633 18.2911 10.8304C18.1934 10.7398 17.8879 10.5887 17.7474 10.5223Z",
    fill: "url(#paint32_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M17.5335 12.8822C17.509 12.8641 17.4785 12.8822 17.4846 12.9124C17.509 13.0635 17.5701 13.3958 17.6435 13.5166C17.7351 13.6676 17.894 13.7462 17.9917 13.6858C18.0895 13.6254 18.0956 13.4562 17.9978 13.2991C17.9306 13.1783 17.6557 12.9729 17.5335 12.8822Z",
    fill: "url(#paint33_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M15.6395 15.6889C15.6456 15.6647 15.615 15.6405 15.5967 15.6526C15.4684 15.7312 15.1751 15.9124 15.0896 16.0212C14.9796 16.1662 14.9674 16.3353 15.059 16.4018C15.1507 16.4683 15.3156 16.4078 15.4256 16.2689C15.5112 16.1662 15.6028 15.8339 15.6395 15.6889Z",
    fill: "url(#paint34_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M15.0774 13.9933C15.1019 13.9812 15.1019 13.9449 15.0774 13.9389C14.9369 13.8845 14.6192 13.7576 14.4787 13.7576C14.2954 13.7576 14.1487 13.8483 14.1487 13.963C14.1487 14.0778 14.2954 14.1685 14.4787 14.1685C14.6131 14.1685 14.9369 14.0476 15.0774 13.9933Z",
    fill: "url(#paint35_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M15.1629 11.8018C15.1751 11.7776 15.1507 11.7534 15.1262 11.7595C14.9796 11.8078 14.6558 11.9166 14.5458 12.0012C14.4053 12.1159 14.3564 12.2791 14.4297 12.3697C14.503 12.4603 14.6741 12.4362 14.8146 12.3214C14.9246 12.2307 15.0957 11.9347 15.1629 11.8018Z",
    fill: "url(#paint36_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M12.1507 14.7962C12.1385 14.8204 12.1568 14.8506 12.1812 14.8385C12.3279 14.8022 12.6639 14.7177 12.7739 14.6391C12.9205 14.5364 12.9877 14.3733 12.9205 14.2827C12.8533 14.192 12.6761 14.1981 12.5295 14.3008C12.4195 14.3854 12.2301 14.6693 12.1507 14.7962Z",
    fill: "url(#paint37_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M18.1507 15.4177C18.1813 15.4177 18.1935 15.3875 18.1752 15.3694C18.0713 15.2606 17.833 15.019 17.7047 14.9585C17.5397 14.886 17.3687 14.9042 17.3198 15.0129C17.2709 15.1217 17.3687 15.2606 17.5336 15.3331C17.6558 15.3875 17.998 15.4056 18.1507 15.4177Z",
    fill: "url(#paint38_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M26.8268 14.295C26.8268 14.2709 26.8329 14.2527 26.8451 14.2346C26.9735 14.3494 27.3339 14.3977 27.6822 14.2044C27.6944 14.2104 27.7128 14.2104 27.725 14.2165C27.7555 14.2225 27.7555 14.2648 27.7311 14.2709C27.5845 14.3252 27.2973 14.434 27.1629 14.44C26.9796 14.4582 26.8268 14.3917 26.8268 14.295Z",
    fill: "url(#paint39_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M25.3176 12.5925C25.3176 12.6046 25.3176 12.6166 25.3054 12.6227C25.171 12.7133 24.8716 12.9066 24.725 12.9429C24.5356 12.9912 24.3584 12.9489 24.3339 12.8462C24.3217 12.7979 24.3461 12.7375 24.4011 12.6891C24.4989 12.8039 24.505 12.9852 24.725 12.8462C24.9266 12.7133 25.1343 12.6468 25.3176 12.5925Z",
    fill: "url(#paint40_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M24.1751 16.0573C24.169 16.0331 24.1629 15.9969 24.1629 15.9546C24.2301 16.0452 24.2912 16.1177 24.3401 16.1479C24.4561 16.2083 24.615 16.1298 24.5845 15.876C24.5967 15.9002 24.6089 15.9183 24.6089 15.9365C24.6517 16.0875 24.5906 16.2385 24.4684 16.2748C24.3462 16.311 24.2179 16.2083 24.1751 16.0573Z",
    fill: "url(#paint41_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M22.9164 14.4884C23.0509 14.5791 23.0509 14.1622 23.0081 13.8722C23.057 13.9266 23.0875 14.0172 23.0936 14.1259C23.0997 14.2468 23.0142 14.5247 22.9714 14.6637C22.9653 14.6939 22.9225 14.6939 22.9164 14.6637C22.8981 14.6153 22.8737 14.5489 22.8492 14.4764C22.8676 14.4643 22.892 14.4703 22.9164 14.4884Z",
    fill: "url(#paint42_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M20.2646 14.5179C20.3441 14.5904 20.4418 14.8381 20.564 15.1341C20.6007 15.2248 20.6434 15.261 20.6801 15.2671C20.6862 15.3335 20.6923 15.4 20.6984 15.4483C20.6984 15.4785 20.6618 15.4906 20.6434 15.4664C20.5396 15.3214 20.3379 15.0254 20.2891 14.8864C20.2341 14.7293 20.228 14.5904 20.2646 14.5179Z",
    fill: "url(#paint43_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M19.8248 12.013C19.8675 12.0251 19.9103 12.0613 19.947 12.1218C20.0569 12.2909 20.393 12.3393 20.7351 12.3151C20.7474 12.3211 20.7535 12.3332 20.7596 12.3393C20.784 12.3574 20.7657 12.3936 20.7412 12.3936C20.5763 12.3876 20.2219 12.3695 20.0814 12.3211C19.9042 12.2486 19.7881 12.1157 19.8248 12.013Z",
    fill: "url(#paint44_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M22.6109 10.6188C22.6292 10.7215 22.5987 10.939 22.5742 11.0478C22.5437 11.1686 22.6536 11.2774 22.8125 11.2351C22.7881 11.2955 22.7453 11.3378 22.6964 11.3378C22.6048 11.3438 22.5192 11.2411 22.507 11.0961C22.4948 10.9934 22.5681 10.7518 22.6048 10.6309C22.5987 10.6249 22.6048 10.6188 22.6109 10.6188Z",
    fill: "url(#paint45_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M19.8553 10.1302C20.008 10.2148 20.2402 10.4686 20.4418 10.5169C20.454 10.5411 20.4602 10.5652 20.4724 10.5834C20.4846 10.6075 20.454 10.6317 20.4296 10.6257C20.3074 10.5713 20.0447 10.4505 19.9653 10.3659C19.8919 10.2873 19.8553 10.2027 19.8553 10.1302Z",
    fill: "url(#paint46_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M17.7045 10.5646C17.6984 10.5525 17.7045 10.5405 17.7106 10.5344C17.8573 10.6613 18.01 11.0117 18.0895 11.0601C18.1689 11.1084 18.2789 11.1748 18.4011 11.0842C18.4072 11.1386 18.3888 11.1869 18.3522 11.2232C18.2666 11.3017 18.1017 11.2594 17.9734 11.1265C17.8878 11.0178 17.7595 10.7036 17.7045 10.5646Z",
    fill: "url(#paint47_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M18.0651 13.5467C18.059 13.6071 18.0346 13.6554 17.9918 13.6796C17.894 13.74 17.7352 13.6615 17.6435 13.5104C17.5702 13.3896 17.5091 13.0573 17.4847 12.9062C17.4847 12.9002 17.4847 12.9002 17.4847 12.9002C17.613 13.0271 17.6863 13.3473 17.7596 13.4681C17.8329 13.5769 17.9185 13.6373 18.0651 13.5467Z",
    fill: "url(#paint48_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M15.2484 16.2571C15.3461 16.2329 15.5539 15.9308 15.6089 15.6529C15.6272 15.6529 15.6394 15.671 15.6333 15.6891C15.5966 15.8341 15.4989 16.1604 15.4195 16.2691C15.3095 16.4141 15.1506 16.4746 15.0529 16.4021C14.9918 16.3598 14.9795 16.2691 15.004 16.1725C15.0712 16.3114 15.1567 16.2812 15.2484 16.2571Z",
    fill: "url(#paint49_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M14.1487 13.9628C14.1487 13.9508 14.1487 13.9387 14.1548 13.9266C14.1853 13.9206 14.222 13.9326 14.2709 13.9689C14.4236 14.0656 14.7658 14.0414 15.0713 13.9447C15.0957 13.9568 15.0957 13.9931 15.0713 13.9991C14.9307 14.0535 14.6069 14.1743 14.4725 14.1743C14.2953 14.1683 14.1487 14.0776 14.1487 13.9628Z",
    fill: "url(#paint50_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M15.1079 11.7655C15.114 11.7655 15.1201 11.7595 15.1262 11.7595C15.1507 11.7534 15.1751 11.7776 15.1629 11.8018C15.0896 11.9347 14.9246 12.2307 14.8146 12.3214C14.6741 12.4362 14.503 12.4603 14.4297 12.3697C14.3992 12.3334 14.393 12.2791 14.4053 12.2247C14.4847 12.2609 14.5886 12.3214 14.6741 12.3274C14.8024 12.3395 14.9429 12.0072 15.1079 11.7655Z",
    fill: "url(#paint51_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M12.1508 14.7962C12.1569 14.7841 12.1691 14.772 12.1752 14.7539C12.3341 14.772 12.5479 14.6452 12.7007 14.4881C12.7862 14.3975 12.8779 14.3854 12.9451 14.3612C12.9451 14.4518 12.884 14.5606 12.774 14.6331C12.6579 14.7116 12.328 14.7962 12.1813 14.8325C12.1569 14.8506 12.1386 14.8204 12.1508 14.7962Z",
    fill: "url(#paint52_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M18.1507 15.4177C18.1813 15.4177 18.1935 15.3875 18.1752 15.3694C18.0713 15.2606 17.833 15.019 17.7047 14.9585C17.5397 14.886 17.3687 14.9042 17.3198 15.0129C17.2709 15.1217 17.3687 15.2606 17.5336 15.3331C17.6558 15.3875 17.998 15.4056 18.1507 15.4177Z",
    fill: "url(#paint53_radial_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M17.448 15.1339C17.558 15.3151 17.8696 15.3816 18.1385 15.3333C18.1507 15.3454 18.1629 15.3574 18.169 15.3695C18.1873 15.3876 18.1751 15.4239 18.1446 15.4179C17.9918 15.4118 17.6497 15.3876 17.5275 15.3333C17.3625 15.2608 17.2708 15.1158 17.3136 15.0131C17.3197 15.007 17.3258 15.001 17.3258 14.9889C17.3747 15.0191 17.4114 15.0674 17.448 15.1339Z",
    fill: "url(#paint54_linear_950_2214)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M19.9531 19.0631C31.4031 19.0631 29.6129 15.858 28.7636 14.1136C29.5518 15.3027 29.9 16.5582 29.9 17.5481C29.9 19.8236 23.118 19.89 20.008 19.89L19.9531 19.0631Z",
    fill: "url(#paint55_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M20.0081 19.8958C16.8982 19.8958 10.1161 19.8234 10.1161 17.5539C10.1161 16.5882 10.4461 15.375 11.1915 14.2161C11.1059 14.379 8.70474 19.0689 19.9531 19.0689L20.0081 19.8958Z",
    fill: "url(#paint56_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M15.4134 23.439C17.2342 24.1331 18.4806 26.1914 19.2993 25.9258C19.2199 26.0042 19.1527 26.0706 19.0977 26.125C19.0183 26.2095 18.8838 26.2155 18.7922 26.1431C15.945 23.8072 14.3686 23.5175 11.6497 22.9863C10.6721 22.7932 10.5132 23.1553 10.2688 22.932C10.1161 22.7932 10.0978 22.5517 10.1589 22.2982C12.1874 23.0889 12.9389 22.5034 15.4134 23.439Z",
    fill: "#FFBC47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M21.8899 24.0426C21.2178 24.2358 20.3319 24.9661 19.7087 25.5395C19.8858 25.0687 20.3502 24.2961 21.4805 23.8253C22.7636 23.2942 24.8288 23.6081 25.7697 23.2037C26.1974 23.0165 27.2483 22.25 28.1587 22.413C28.8369 22.5337 29.3074 22.2802 29.4112 21.8999C29.4418 22.0025 29.4662 22.1172 29.4968 22.25C29.6801 23.1191 27.5477 22.3948 26.4113 23.1674C25.2687 23.9461 23.0386 23.7107 21.8899 24.0426Z",
    fill: "url(#paint57_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M11.2709 28.2678C10.5255 27.7245 10.1956 26.6683 10.33 25.4309C10.3483 25.449 10.3728 25.4611 10.3911 25.4792C10.44 25.5154 10.4949 25.5516 10.5499 25.5878C10.2872 28.1652 13.6538 29.6862 20.6985 29.6862C27.4989 29.6862 29.0203 28.3704 29.6007 25.4913C29.6068 25.4852 29.6129 25.4792 29.619 25.4792C29.6374 25.4611 29.6618 25.449 29.6801 25.4309C29.8146 26.6683 29.4846 27.7306 28.7392 28.2678C27.3767 29.2577 24.6883 29.994 20.002 29.994C15.3218 29.994 12.6334 29.2577 11.2709 28.2678Z",
    fill: "url(#paint58_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M26.5824 21.7854C26.7229 21.7613 26.9123 21.713 27.1628 21.4655C27.4133 21.218 28.397 21.5561 28.843 21.2301C29.2218 20.9525 29.4662 20.5843 29.839 20.5179C29.9306 20.5541 29.9917 20.5843 29.9978 20.6084C30.0284 20.6809 29.7351 20.8499 29.3746 21.1517C29.0691 21.4052 28.6292 21.5621 28.397 21.5621C28.1648 21.5621 27.3094 21.4897 27.0345 21.713C26.839 21.8699 26.7473 21.7794 26.5824 21.7854Z",
    fill: "url(#paint59_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M10.6415 21.6526C10.8492 21.8578 12.0773 21.713 12.7006 21.5138C13.3238 21.3146 14.3197 22.3105 14.4419 22.2864C14.9796 22.1958 15.3889 22.0751 15.6455 22.2864C15.9022 22.4976 15.9205 22.2381 16.0855 22.1958C16.2504 22.1536 17.0936 22.1838 17.228 22.5882C17.2952 22.7873 17.393 22.8175 17.5274 22.8779C17.3319 23.0288 17.3685 22.9926 17.1058 22.733C16.8125 22.4433 16.2138 22.2562 16.1282 22.3407C16.0427 22.4252 15.9449 22.6304 15.7311 22.4131C15.5172 22.1958 14.9368 22.2622 14.7046 22.3528C14.4724 22.4433 14.2464 22.3407 14.2158 22.3105C14.1853 22.2803 13.672 22.1234 13.1893 21.8276C13.0671 21.7552 11.6313 21.7794 11.3441 21.8578C11.057 21.9363 10.7209 21.8578 10.7209 21.8578C10.7209 21.8578 10.5193 21.4595 10.3482 21.387C10.171 21.3146 10.0061 21.1154 10.0061 21.0551C10.5743 21.3508 10.4277 21.4413 10.6415 21.6526Z",
    fill: "url(#paint60_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M19.7087 22.5038C20.2586 21.9299 20.7474 22.6247 21.004 22.6368C21.4928 22.6549 21.8594 21.8211 22.2382 22.5582C22.1405 22.4978 22.0488 22.4313 21.9999 22.4193C21.89 22.3891 21.4623 22.7516 21.1751 22.7516C20.8879 22.7516 20.503 22.6609 20.3197 22.5401C20.1364 22.4193 19.2505 22.9509 19.1588 23.0838C19.0977 23.1745 18.9083 23.108 18.7006 22.9932C18.9511 23.0053 19.1833 23.0536 19.7087 22.5038Z",
    fill: "url(#paint61_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M22.8919 22.021C22.6964 21.9485 22.171 21.737 22.5376 21.7612C22.9042 21.7793 24.0651 22.456 24.3217 22.311C24.5783 22.166 25.1587 22.3956 25.4092 22.1418C25.6659 21.8881 26.338 21.8518 26.338 21.8518C25.9836 22.0331 25.5437 22.3472 25.3298 22.3472C25.116 22.3472 24.5355 22.3593 24.3522 22.4077C24.1689 22.456 23.5274 22.2385 23.3441 22.1781C23.1608 22.1177 23.008 22.166 23.008 22.166C23.008 22.166 22.5498 22.3956 22.507 22.5768C22.5192 22.1841 23.0814 22.0935 22.8919 22.021Z",
    fill: "url(#paint62_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M26.1424 28.2676C26.3929 28.008 26.5396 27.3682 26.509 26.7586C27.9143 26.4266 28.9286 25.98 29.6251 25.473C29.6434 25.4549 29.6679 25.4428 29.6862 25.4247C29.8206 26.662 29.4907 27.7244 28.7453 28.2615C27.3827 29.2514 24.6944 29.9878 20.008 29.9878C23.3013 29.9938 25.1893 29.2575 26.1424 28.2676Z",
    fill: "url(#paint63_linear_950_2214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M10.3299 25.4308C10.3482 25.4489 10.3726 25.461 10.391 25.4791C11.0875 25.9861 12.1017 26.4327 13.507 26.7647C13.4704 27.3743 13.6231 28.0142 13.8736 28.2737C14.8329 29.2636 16.7209 30 20.008 30C15.3217 30 12.6333 29.2636 11.2708 28.2737C10.5254 27.7244 10.1954 26.6681 10.3299 25.4308Z",
    fill: "url(#paint64_linear_950_2214)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_950_2214",
    x1: 22.5944,
    y1: 22.491,
    x2: 14.7254,
    y2: 32.0416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89043",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9964 24.6651) rotate(-178.771) scale(13.4963 3.50989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2426,
    stopColor: "#643800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5E3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7652,
    stopColor: "#4E2C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_950_2214",
    x1: 14.5955,
    y1: 24.6722,
    x2: 9.68681,
    y2: 24.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8063,
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8662,
    stopColor: "#4B2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9402,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_950_2214",
    x1: 20.004,
    y1: 22.141,
    x2: 20.0438,
    y2: 27.7342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3002,
    stopColor: "#5E3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#4E2C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_950_2214",
    x1: 23.3284,
    y1: 24.9977,
    x2: 38.2224,
    y2: 21.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9318 23.0015) rotate(179.94) scale(14.8431 2.85052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0891 28.093) rotate(180) scale(13.5101 3.17244)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_950_2214",
    x1: 18.513,
    y1: 22.8728,
    x2: 19.7467,
    y2: 17.1124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00293411,
    stopColor: "#FFD65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    stopColor: "#FFD255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB4B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8445 22.3169) rotate(180) scale(6.71439 6.63302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_950_2214",
    x1: 18.0468,
    y1: 26.0175,
    x2: 20.7379,
    y2: 18.6926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_950_2214",
    x1: 26.905,
    y1: 19.8678,
    x2: 28.2887,
    y2: 21.6948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_950_2214",
    x1: 19.0774,
    y1: 20.0544,
    x2: 19.1967,
    y2: 22.5594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_950_2214",
    x1: 27.1472,
    y1: 24.3309,
    x2: 27.5945,
    y2: 19.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_950_2214",
    x1: 17.7596,
    y1: 23.4827,
    x2: 18.2069,
    y2: 18.5323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_950_2214",
    x1: 13.1307,
    y1: 19.3257,
    x2: 11.553,
    y2: 21.6073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_950_2214",
    x1: 14.609,
    y1: 21.0606,
    x2: 14.1409,
    y2: 21.7369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9699 21.0763) rotate(180) scale(9.26023 1.16728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#4B8C1C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B8C1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7939 20.6384) rotate(180) scale(11.84 2.53346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2904,
    stopColor: "#E74939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#BD2719"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1748 17.8973) rotate(180) scale(12.8378 4.09889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#F78174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6656,
    stopColor: "#E74939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#BD2719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_950_2214",
    x1: 19.9966,
    y1: 26.1317,
    x2: 19.5593,
    y2: 33.2145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_950_2214",
    x1: 20.3273,
    y1: 15.3205,
    x2: 21.5503,
    y2: 7.10733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA25F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4407,
    stopColor: "#F3A968",
    stopOpacity: 0.9868
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB87A",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3342 11.8962) rotate(-169.834) scale(4.2666 2.36609)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD2A8",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD2A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_950_2214",
    x1: 21.6863,
    y1: 9.03421,
    x2: 19.2394,
    y2: 21.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#E89043",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89043",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_950_2214",
    x1: 20.9787,
    y1: 10.133,
    x2: 19.5471,
    y2: 21.1631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89043",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89043",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3989 15.8715) rotate(180) scale(0.329771 0.326089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9317 14.2555) rotate(180) scale(0.328404 0.324734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.47 14.9718) rotate(180) scale(0.395898 0.391476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2727 14.2504) rotate(167.16) scale(0.343552 0.340097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8253 12.7568) rotate(180) scale(0.378229 0.374002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2983 12.1584) rotate(180) scale(0.377796 0.373574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6668 10.9763) rotate(180) scale(0.285615 0.282424)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1654 10.3139) rotate(180) scale(0.311578 0.308095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0557 10.8893) rotate(180) scale(0.361376 0.357341)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7791 13.2896) rotate(180) scale(0.360216 0.356193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3214 16.0457) rotate(180) scale(0.360931 0.356901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6233 13.9622) rotate(180) scale(0.36643 0.362341)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7832 12.0891) rotate(180) scale(0.361096 0.357063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5481 14.5323) rotate(180) scale(0.360558 0.356532)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7444 15.1642) rotate(180) scale(0.358188 0.354189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_950_2214",
    x1: 27.742,
    y1: 14.3275,
    x2: 26.8243,
    y2: 14.3275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_950_2214",
    x1: 25.3172,
    y1: 12.7787,
    x2: 24.3326,
    y2: 12.7787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_950_2214",
    x1: 24.4096,
    y1: 15.561,
    x2: 24.3897,
    y2: 16.3565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_950_2214",
    x1: 23.0974,
    y1: 14.2776,
    x2: 22.8508,
    y2: 14.2776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_950_2214",
    x1: 20.6984,
    y1: 14.9964,
    x2: 20.2416,
    y2: 14.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_950_2214",
    x1: 20.7763,
    y1: 12.2046,
    x2: 19.8201,
    y2: 12.2046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_950_2214",
    x1: 22.8091,
    y1: 10.9786,
    x2: 22.4996,
    y2: 10.9786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_950_2214",
    x1: 20.4742,
    y1: 10.3769,
    x2: 19.8575,
    y2: 10.3769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_950_2214",
    x1: 18.4052,
    y1: 10.8951,
    x2: 17.705,
    y2: 10.8951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_950_2214",
    x1: 18.0678,
    y1: 13.3026,
    x2: 17.4881,
    y2: 13.3026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_950_2214",
    x1: 15.6427,
    y1: 16.046,
    x2: 15.0007,
    y2: 16.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_950_2214",
    x1: 15.0973,
    y1: 14.0453,
    x2: 14.1492,
    y2: 14.0453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_950_2214",
    x1: 15.1678,
    y1: 12.0891,
    x2: 14.3995,
    y2: 12.0891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5481 14.6054) rotate(180) scale(0.330761 0.327065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_950_2214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7444 15.1642) rotate(180) scale(0.358188 0.354189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_950_2214",
    x1: 18.1826,
    y1: 15.2012,
    x2: 17.3061,
    y2: 15.2012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_950_2214",
    x1: 22.9248,
    y1: 14.2391,
    x2: 29.6383,
    y2: 27.1028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_950_2214",
    x1: 17.8488,
    y1: 13.2188,
    x2: 9.62997,
    y2: 27.5505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_950_2214",
    x1: 23.4959,
    y1: 26.9329,
    x2: 25.8269,
    y2: 20.5882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_950_2214",
    x1: 20.0454,
    y1: 25.095,
    x2: 19.6876,
    y2: 33.5053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_950_2214",
    x1: 30.0039,
    y1: 21.1604,
    x2: 26.579,
    y2: 21.1604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_950_2214",
    x1: 13.3134,
    y1: 23.1325,
    x2: 13.9009,
    y2: 21.5335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_950_2214",
    x1: 20.45,
    y1: 23.4293,
    x2: 20.4898,
    y2: 21.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_950_2214",
    x1: 23.8918,
    y1: 23.0921,
    x2: 24.5834,
    y2: 21.2114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_950_2214",
    x1: 25.7714,
    y1: 28.2335,
    x2: 28.6864,
    y2: 29.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_950_2214",
    x1: 14.2198,
    y1: 28.2815,
    x2: 9.97124,
    y2: 30.9028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger-icon.cff931cfbbe8162458f200d9dda7283d.svg";
export { ForwardRef as ReactComponent };